module.exports = __webpack_public_path__ + "static/media/173.cc04f6ff.webp";